import React from 'react';
import { motion } from 'framer-motion';

const countries = [
  { code: 'BE', name: 'België', type: 'Hoofdkantoor • VG Vergund', primary: true },
  { code: 'PL', name: 'Polen', type: 'Primaire bronmarkt • 8 sectoren', primary: true },
  { code: 'RO', name: 'Roemenië', type: 'Primaire bronmarkt • 6 sectoren', primary: true },
  { code: 'DE', name: 'Duitsland', type: 'Strategische markt • 5 sectoren', primary: false },
  { code: 'NL', name: 'Nederland', type: 'Actieve partnermarkt • 5 sectoren', primary: false },
  { code: 'CZ', name: 'Tsjechië', type: 'Vakgeschoolde sector • 4 sectoren', primary: false },
  { code: 'SK', name: 'Slowakije', type: 'Industriële specialisten • 4 sectoren', primary: false },
  { code: 'BG', name: 'Bulgarije', type: 'Groeimarkt • 3 sectoren', primary: false },
  { code: 'HU', name: 'Hongarije', type: 'Technisch talent • 3 sectoren', primary: false },
  { code: 'PT', name: 'Portugal', type: 'Geschoolde professionals • 3 sectoren', primary: false },
  { code: 'HR', name: 'Kroatië', type: 'Engineering & bouw • 2 sectoren', primary: false },
  { code: 'FR', name: 'Frankrijk', type: 'Grensoverschrijdende expertise • 2 sectoren', primary: false },
];

const EUNetwerk = () => {
  return (
    <section id="eu-netwerk" className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <motion.p
              className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4"
              style={{ color: '#00E5A0' }}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              12 ACTIEVE MARKTEN
            </motion.p>
            <motion.h2
              className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold leading-none mb-8"
              style={{ color: '#FFFFFF' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              EU<br /><span style={{ color: '#00E5A0' }}>NETWERK</span>
            </motion.h2>
            <motion.p
              className="text-base leading-relaxed mb-8"
              style={{ color: '#888888' }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              BVM Group is actief in 12 EU-lidstaten. Van kandidatenwerving tot grensoverschrijdende arbeidscontracten — één partner beheert uw volledige EU-personeelsbehoefte.
            </motion.p>
            {/* Country grid badges */}
            <motion.div
              className="flex flex-wrap gap-2"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              {countries?.map((c) => (
                <span
                  key={c?.code}
                  className="px-3 py-1.5 text-xs font-body font-semibold rounded-sm"
                  style={{
                    background: c?.primary ? 'rgba(0,229,160,0.15)' : 'rgba(255,255,255,0.05)',
                    border: `1px solid ${c?.primary ? 'rgba(0,229,160,0.4)' : '#2A2A2A'}`,
                    color: c?.primary ? '#00E5A0' : '#888888'
                  }}
                >
                  {c?.code}
                </span>
              ))}
            </motion.div>
          </div>

          {/* Right — table */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            style={{ border: '1px solid #1A1A1A' }}
          >
            {/* Table header */}
            <div className="grid grid-cols-[56px_1fr_1fr] px-4 py-3" style={{ background: '#141414', borderBottom: '1px solid #1A1A1A' }}>
              <span className="text-xs font-body font-semibold tracking-widest uppercase" style={{ color: '#555555' }}>Code</span>
              <span className="text-xs font-body font-semibold tracking-widest uppercase" style={{ color: '#555555' }}>Land</span>
              <span className="text-xs font-body font-semibold tracking-widest uppercase" style={{ color: '#555555' }}>Type</span>
            </div>
            {countries?.map((c, i) => (
              <motion.div
                key={c?.code}
                className="grid grid-cols-[56px_1fr_1fr] px-4 py-3 group"
                style={{ borderBottom: i < countries?.length - 1 ? '1px solid #1A1A1A' : 'none', background: '#0A0A0A' }}
                initial={{ opacity: 0, x: 10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.05 * i }}
                whileHover={{ background: '#0F0F0F' }}
              >
                <span
                  className="text-xs font-body font-bold"
                  style={{ color: c?.primary ? '#00E5A0' : '#555555' }}
                >
                  {c?.code}
                </span>
                <span className="text-sm font-body font-medium text-white">{c?.name}</span>
                <span className="text-xs font-body" style={{ color: '#666666' }}>{c?.type}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default EUNetwerk;
